export const environment = {
  apiBaseUrl: 'https://api-stage.kochikachar-bornomala.de/',
};
